const normalize = (s : string) =>
  (s ?? '')
    .toString()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()

const onlyDigits = (s : string) => (s ?? '').toString().replace(/\D+/g, '')

const synonyms = [
  {
    t: 'fc',
    s: ['football & club', 'floorball & club', 'fc']
  },
  {
    t: 'football & club',
    s: ['football & club', 'fc']
  },
  {
    t: 'ff',
    s: ['fotbollsförening', 'friidrottsförening', 'flygförening', 'ff']
  },
  {
    t: 'fotbollsförening',
    s: ['fotbollsförening', 'ff']
  },
  {
    t: 'friidrottsförening',
    s: ['friidrottsförening', 'ff']
  },
  {
    t: 'flygförening',
    s: ['flygförening', 'ff']
  },
  {
    t: 'fk',
    s: ['fotbollsklubb', 'flygklubb', 'föreningsklubb', 'fk']
  },
  {
    t: 'fotbollsklubb',
    s: ['fotbollsklubb', 'fk']
  },
  {
    t: 'flygklubb',
    s: ['flygklubb', 'fk']
  },
  {
    t: 'föreningsklubb',
    s: ['föreningsklubb', 'fk']
  },
  {
    t: 'gais',
    s: ['göteborgs & atlet- & idrottsällskap', 'gais']
  },
  {
    t: 'göteborgs & atlet- & idrottsällskap',
    s: ['göteborgs & atlet- & idrottsällskap', 'gais']
  },
  {
    t: 'gf',
    s: ['gymnastikförening', 'gf']
  },
  {
    t: 'gymnastikförening',
    s: ['gymnastikförening', 'gf']
  },
  {
    t: 'gif',
    s: ['gymnastik- & och & idrottsförening', 'gif']
  },
  {
    t: 'gymnastik- & och & idrottsförening',
    s: ['gymnastik- & och & idrottsförening', 'GoIF', 'gif']
  },
  {
    t: 'gk',
    s: ['golfklubb', 'gymnastikklubb', 'gk']
  },
  {
    t: 'golfklubb',
    s: ['golfklubb', 'gk']
  },
  {
    t: 'gymnastikklubb',
    s: ['gymnastikklubb', 'gk']
  },
  {
    t: 'GoIF',
    s: ['gymnastik- & och & idrottsförening', 'GoIF']
  },
  {
    t: 'hc',
    s: ['hockey & club', 'hc']
  },
  {
    t: 'hockey & club',
    s: ['hockey & club', 'hc']
  },
  {
    t: 'hf',
    s: ['handbollsförening', 'hockeyförening', 'hf']
  },
  {
    t: 'handbollsförening',
    s: ['handbollsförening', 'hf']
  },
  {
    t: 'hockeyförening',
    s: ['hockeyförening', 'hf']
  },
  {
    t: 'hif',
    s: ['helsingborgs & if', 'hammarby & if', 'hif']
  },
  {
    t: 'helsingborgs & if',
    s: ['helsingborgs & if', 'hif']
  },
  {
    t: 'hammarby & if',
    s: ['hammarby & if', 'hif']
  },
  {
    t: 'hk',
    s: ['handbollsklubb', 'hockeyklubb', 'hk']
  },
  {
    t: 'handbollsklubb',
    s: ['handbollsklubb', 'hk']
  },
  {
    t: 'hockeyklubb',
    s: ['hockeyklubb', 'hk']
  },
  {
    t: 'ibc',
    s: ['innebandy & club', 'ibc']
  },
  {
    t: 'innebandy & club',
    s: ['innebandy & club', 'ibc', 'ic']
  },
  {
    t: 'ibf',
    s: ['innebandyförening', 'ibf']
  },
  {
    t: 'innebandyförening',
    s: ['innebandyförening', 'ibf']
  },
  {
    t: 'ibk',
    s: ['innebandyklubb', 'ibk']
  },
  {
    t: 'innebandyklubb',
    s: ['innebandyklubb', 'ibk']
  },
  {
    t: 'ic',
    s: ['innebandy & club', 'ic']
  },
  {
    t: 'if',
    s: ['idrottsförening', 'if']
  },
  {
    t: 'idrottsförening',
    s: ['idrottsförening', 'if']
  },
  {
    t: 'ifk',
    s: ['idrottsföreningen & kamraterna', 'ifk']
  },
  {
    t: 'idrottsföreningen & kamraterna',
    s: ['idrottsföreningen & kamraterna', 'ifk']
  },
  {
    t: 'ik',
    s: ['idrottsklubb', 'ik']
  },
  {
    t: 'idrottsklubb',
    s: ['idrottsklubb', 'ik']
  },
  {
    t: 'iku',
    s: ['idrottsklubben & unga', 'iku']
  },
  {
    t: 'idrottsklubben & unga',
    s: ['idrottsklubben & unga', 'iku']
  },
  {
    t: 'kfuk',
    s: ['kristliga & föreningen & av & unga & kvinnor', 'kfuk']
  },
  {
    t: 'kristliga & föreningen & av & unga & kvinnor',
    s: ['kristliga & föreningen & av & unga & kvinnor', 'kfuk']
  },
  {
    t: 'kfum',
    s: ['kristliga & föreningen & av & unga & män', 'kfum']
  },
  {
    t: 'kristliga & föreningen & av & unga & män',
    s: ['kristliga & föreningen & av & unga & män', 'kfum']
  },
  {
    t: 'kif',
    s: ['kvinnors & idrottsförening', 'kif']
  },
  {
    t: 'kvinnors & idrottsförening',
    s: ['kvinnors & idrottsförening', 'kif']
  },
  {
    t: 'kk',
    s: ['karateklubb', 'kanotklubb', 'konståkningsklubb', 'kk']
  },
  {
    t: 'karateklubb',
    s: ['karateklubb', 'kk']
  },
  {
    t: 'kanotklubb',
    s: ['kanotklubb', 'kk']
  },
  {
    t: 'konståkningsklubb',
    s: ['konståkningsklubb', 'kk']
  },
  {
    t: 'mk',
    s: ['motorklubb', 'motorcykelklubb', 'mk']
  },
  {
    t: 'motorklubb',
    s: ['motorklubb', 'mk']
  },
  {
    t: 'motorcykelklubb',
    s: ['motorcykelklubb', 'mk']
  },
  {
    t: 'ok',
    s: ['orienteringsklubb', 'ok']
  },
  {
    t: 'orienteringsklubb',
    s: ['orienteringsklubb', 'ok']
  },
  {
    t: 'rc',
    s: ['running & club', 'rc']
  },
  {
    t: 'running & club',
    s: ['running & club', 'rc']
  },
  {
    t: 'rk',
    s: ['ridklubb', 'roddklubb', 'rk']
  },
  {
    t: 'ridklubb',
    s: ['ridklubb', 'rk']
  },
  {
    t: 'roddklubb',
    s: ['roddklubb', 'rk']
  },
  {
    t: 'rs',
    s: ['ridskola', 'ridsällskap', 'rs']
  },
  {
    t: 'ridskola',
    s: ['ridskola', 'rs']
  },
  {
    t: 'ridsällskap',
    s: ['ridsällskap', 'rs']
  },
  {
    t: 'sc',
    s: ['sportclub', 'sport & club', 'sc']
  },
  {
    t: 'sportclub',
    s: ['sportclub', 'sc']
  },
  {
    t: 'sport & club',
    s: ['sport & club', 'sc']
  },
  {
    t: 'sif',
    s: ['studenternas & idrottsförening', 'sif']
  },
  {
    t: 'studenternas & idrottsförening',
    s: ['studenternas & idrottsförening', 'sif']
  },
  {
    t: 'sk',
    s: ['simklubb', 'sportklubb', 'skidklubb', 'skridskoklubb', 'scoutkår', 'sk']
  },
  {
    t: 'simklubb',
    s: ['simklubb', 'sk']
  },
  {
    t: 'sportklubb',
    s: ['sportklubb', 'sk']
  },
  {
    t: 'skidklubb',
    s: ['skidklubb', 'sk']
  },
  {
    t: 'skridskoklubb',
    s: ['skridskoklubb', 'sk']
  },
  {
    t: 'scoutkår',
    s: ['scoutkår', 'sk']
  },
  {
    t: 'ss',
    s: ['simsällskap', 'segelsällskap', 'sportsällskap', 'ss']
  },
  {
    t: 'simsällskap',
    s: ['simsällskap', 'ss']
  },
  {
    t: 'segelsällskap',
    s: ['segelsällskap', 'ss']
  },
  {
    t: 'sportsällskap',
    s: ['sportsällskap', 'ss']
  },
  {
    t: 'tk',
    s: ['tennisklubb', 'tk']
  },
  {
    t: 'tennisklubb',
    s: ['tennisklubb', 'tk']
  },
  {
    t: 'vk',
    s: ['volleybollklubb', 'vk']
  },
  {
    t: 'volleybollklubb',
    s: ['volleybollklubb', 'vk']
  },
  {
    t: 'ösk',
    s: ['örebro & sportklub', 'ösk']
  },
  {
    t: 'örebro & sportklub',
    s: ['örebro & sportklub', 'ösk']
  }
]

const synonymMap : any = {}
synonyms.forEach((entry) => {
  const key = normalize(entry.t)
  synonymMap[key] = entry.s.map(normalize)
})

// Expand query into synonyms
const expandQuery = (query : string) => {
  const qNorm = normalize(query)
  const words = qNorm.split(/\s+/)
  const expanded = new Set([qNorm])

  words.forEach((word) => {
    if (synonymMap[word]) {
      synonymMap[word].forEach((syn : any) => expanded.add(syn))
    }
  })

  return Array.from(expanded)
}

const searchUtforare = (data : any, query : string) => {
  const expandedQueries = expandQuery(query)
  const qDigits = onlyDigits(query)
  
  return (data?.u ?? []).filter((u: any) => {
    const nameNorm = normalize(u?.n)
    const nameMatch = expandedQueries.some((eq) => nameNorm.includes(eq))
    const orgMatch = qDigits ? onlyDigits(u?.o).includes(qDigits) : false
    return nameMatch || orgMatch
  })
}
let data : any = null
document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('search_query')
  const resultList = document.getElementById('search_result')

  if(input?.dataset.jsonpath === undefined || input.dataset.jsonpath === null) {
    return;
  }
  
fetch(input?.dataset.jsonpath ?? '')
  .then((r) => r.json())
  .then((json) => (data = json))
  .catch((err) => console.error('Failed to load data', err))

  let keyboardInteraction = false

  input?.addEventListener('input', (e) => {
    const query = (e.target as HTMLInputElement).value.trim()
    resultList!.innerHTML = '' // clear previous results

    if (query.length > 1 && data) {
      const matches = searchUtforare(data, query)

      matches.forEach((m : any, i : number) => {
        const li = document.createElement('li')

        const nameSpan = document.createElement('span')
        nameSpan.className = 'total_name'
        nameSpan.textContent = m.n

        const orgSpan = document.createElement('span')
        orgSpan.className = 'total_org'
        orgSpan.textContent = `Organisationsnummer`
        const orgNrSpan = document.createElement('span')
        orgNrSpan.className = 'org_number'
        orgNrSpan.textContent = `${m.o}`

        li.append(nameSpan, orgSpan, orgNrSpan)
        resultList?.appendChild(li)

        if (i < matches.length - 1) {
          const hr = document.createElement('hr')
          hr.className = 'list-seperator'
          resultList?.appendChild(hr)
        }
      })

      if (matches.length > 0) {
        resultList?.classList.add('show')
      } else {
        resultList?.classList.remove('show')
      }

      document.getElementById('search_total')!.textContent = `${matches.length} ${
        matches.length === 1 ? 'träff' : 'träffar'
      }`
    } else {
      resultList!.innerHTML = ''
      resultList?.classList.remove('show')

      document.getElementById('search_title')!.textContent = ''
      document.getElementById('search_total')!.textContent = ''
    }
  })

  window.addEventListener('keydown', (e) => {
    if (['Tab'].includes(e.key)) keyboardInteraction = true
  })

  window.addEventListener('mousedown', () => {
    keyboardInteraction = false
  })

  input?.addEventListener('focus', () => {
    if (keyboardInteraction) {
      input.setAttribute('focus', 'true')
    } else {
      input.removeAttribute('focus')
    }
  })

  input?.addEventListener('blur', () => {
    input.removeAttribute('focus')
  })
})